// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"c657f4fe","348":"99982adf","361":"b0baa334","541":"a894353a","723":"ce975205","862":"0decdc1c","961":"8b003c65"}[chunkId] + ".chunk.js";
};